import React, { useContext, useEffect, useState } from 'react';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { ProvinceContext, ProvinceProvider } from './ProvinceContext';
import { ProvinceList } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        navigateTo
    } = useContext(NavContext);

    const {

        state,
        setState,

        isLoadingRegioni,
        getRegioniAsync,

        isLoadingProvince,
        getProvinceAsync,

        isDeletingProvincia,
        deleteProvinciaAsync,

    } = useContext(ProvinceContext);

    const {
        deleteProvincia
    } = state;

    const loadMoreHandler = async (pageIndex, pageSize, searchText, validFilter, regioneFilter) => {
        await getProvinceAsync(pageIndex, pageSize, searchText, validFilter, regioneFilter);
    }

    const [searchText, setSearchText] = useState("");
    const searchClickHandler = async (searchText) => {
        setSearchText(searchText);
    };

    const provinceListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(NavRoutes.ProvinciaAdd, "_blank").focus();
                break;
            case "Delete":
                await deleteProvinciaAsync(data.id);
                break;
            default:
                break;
        }
    };

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingProvince || isDeletingProvincia);
    }, [isLoadingProvince, isDeletingProvincia])

    useEffect(() => {
        if (user && deleteProvincia)
            deleteProvinciaAsync(deleteProvincia.id);
        // setOpenDeleteProvinciaDialog(true);
    }, [deleteProvincia, user])

    useEffect(() => {
        if (user) {
            addBreadcrumbToken("Province");
            getProvinceAsync(0, 25, searchText, true);
            getRegioniAsync();
        }
    }, [user]);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    return (
        <>
            <Container>
                <Grid container>
                    {isLoading && <LinearProgress />}
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            search
                            onSearchClick={searchClickHandler}
                            title="Province"
                            subtitle="Gestisci le province" />
                    </Grid>
                    <Grid item xs={12}>
                        <ProvinceList
                            searchText={searchText}
                            itemsPerPage={25}
                            onLoadMore={loadMoreHandler}
                            disabled={isLoading}
                            onActionClick={provinceListActionClickHandler} />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const ProvincePage = () => {

    return (
        <ProvinceProvider>
            <PageContent />
        </ProvinceProvider>
    );
}